export default __webpack_public_path__ + "static/media/vp2_2025.0be0e20a.jpg";